import styled, { css } from 'styled-components';
import { rem } from 'polished';
var Options = styled.div.withConfig({
  displayName: "Options",
  componentId: "sc-1jxy1if-0"
})(["", ""], function (_ref) {
  var isRow = _ref.isRow;
  return isRow && css(["padding-right:", ";"], rem(32));
});
export default Options;